import React, { useContext } from 'react';
import './Symptoms.scss';
import IconList from '../../components/IconList/IconList';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import iconOne from '../../assets/symptoms/1.png';
import iconTwo from '../../assets/symptoms/2.png';
import iconThree from '../../assets/symptoms/3.png';
import iconFour from '../../assets/symptoms/4.png';
import iconFive from '../../assets/symptoms/5.png';
import { LanguageContext } from '../../context/LanguageContext';

const Symptoms = () => {
    const { t } = useContext(LanguageContext);

    const symptomsData = [
        {
            'icon' : iconOne,
            'title' : t('dentalSymptoms.symptoms.0.title'),
            'description': t('dentalSymptoms.symptoms.0.description')
        },
        {
            'icon' : iconTwo,
            'title' : t('dentalSymptoms.symptoms.1.title'),
            'description': t('dentalSymptoms.symptoms.1.description')
        },
        {
            'icon' : iconThree,
            'title' : t('dentalSymptoms.symptoms.2.title'),
            'description': t('dentalSymptoms.symptoms.2.description')
        },
        {
            'icon' : iconFour,
            'title' : t('dentalSymptoms.symptoms.3.title'),
            'description': t('dentalSymptoms.symptoms.3.description')
        },
        {
            'icon' : iconFive,
            'title' : t('dentalSymptoms.symptoms.4.title'),
            'description': t('dentalSymptoms.symptoms.4.description')
        }
    ]

    return (
        <section className='symptoms-section section-common pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle 
                    subTitle={t('dentalSymptoms.sectionTitle')}
                    title={t('dentalSymptoms.title')}
                    description={t('dentalSymptoms.description')}
                />

                <div className="row">
                    {
                        symptomsData.map((singleSymptoms, index) => 
                            <IconList 
                                key={index}
                                icon={singleSymptoms.icon}
                                title={singleSymptoms.title}
                                description={singleSymptoms.description}
                            />
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Symptoms;